import showConfirmDialog from '../components/ConfirmDialog';
import { DialogResponse } from './DialogResponse';

export interface ConfirmCustomizationOptions {
    bodyElement?: JSX.Element;
    okText?: string;
    continueText?: string;
    cancelText?: string;
    okToolTip?: string;
    continueToolTip?: string;
    cancelToolTip?: string;
    hideCancelButton?: boolean;
    showContinueButton?: boolean;
    delayCallbackAfterAnimation?: boolean;
    containerClassName?: string;
    preventSoftDismiss?: boolean;
    focusOnCancel?: boolean;
    focusSelector?: string;
}

export default function confirm(
    title: string,
    subText?: string,
    resolveImmediately?: boolean,
    customizationOptions?: ConfirmCustomizationOptions
): Promise<DialogResponse> {
    if (resolveImmediately) {
        // This is useful in cases where the user wants to display the
        // dialog only if a certain condition is met. It will allow
        // to keep the code simple for who uses it.
        return Promise.resolve(DialogResponse.ok);
    }

    return new Promise<DialogResponse>((resolve, reject) => {
        showConfirmDialog(
            title,
            subText,
            customizationOptions,
            () => {
                resolve(DialogResponse.ok);
            },
            () => {
                resolve(DialogResponse.cancel);
            },
            () => {
                resolve(DialogResponse.dismiss);
            },
            () => {
                resolve(DialogResponse.continue);
            }
        );
    });
}
